import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getCareerPage = createAsyncThunk('careerPage/getCareerPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getCareerPage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
export const sendCareerCv = createAsyncThunk('careerPage/sendCareerCv', async (payload, thunkAPI) => {
  try {
    const { formData, lang } = payload;
    const { data } = await Api.sendCareerCv(formData, lang);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
